module.exports = __webpack_public_path__ + "static/Q2Answer5_Vegetables_ChantalGarnier-24e106ee4fe8aa8ba65277afc50c1819.jpg";